import { trans } from "@mongez/localization";
import { Product, productAtom } from "core/catalog";
import { cn } from "core/shared";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { ArrowLeft, ArrowRight, BaseLink } from "~/design-system/components";
import { Image } from "~/modules/shared/components";
import { URLS } from "~/shared/urls";

export function ProductVariations() {
  const product: Product = productAtom.use("product");

  if (!product || !product.variations || !product.variations.length)
    return null;

  return (
    <div className="border-border flex max-w-full flex-1 flex-col gap-4 border-t pt-4 select-none">
      <div className="flex items-center justify-between">
        <h3 className="w-fit text-lg font-bold">
          {trans("productVariations")}
        </h3>
        <div className="flex items-center gap-2">
          <button className="variation-prev border-primary-default text-primary-default hover:bg-primary-default flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border transition-all hover:text-white disabled:cursor-not-allowed disabled:opacity-30">
            <ArrowLeft />
          </button>
          <button className="variation-next border-primary-default text-primary-default hover:bg-primary-default flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border transition-all hover:text-white disabled:cursor-not-allowed disabled:opacity-30">
            <ArrowRight />
          </button>
        </div>
      </div>
      <div className="w-[99%]">
        <Swiper
          modules={[Navigation]}
          onBeforeInit={(swiper) => {
            if (
              typeof swiper.params.navigation !== "boolean" &&
              swiper.params.navigation
            ) {
              swiper.params.navigation.prevEl = ".variation-prev";
              swiper.params.navigation.nextEl = ".variation-next";
            }
          }}
          navigation={{
            prevEl: ".variation-prev",
            nextEl: ".variation-next",
          }}
          slidesPerView="auto"
          spaceBetween={10}
          className="max-w-full!"
        >
          {product.variations.map((variation) => (
            <SwiperSlide key={variation.id} className="w-fit!">
              <BaseLink
                replace
                to={URLS.ourCakes.view(variation)}
                className={cn(
                  "relative flex h-20 w-24 items-center justify-center overflow-hidden rounded-2xl border bg-white lg:h-28",
                  variation.id === product.id &&
                    "border-primary-default border-2",
                )}
              >
                <Image
                  image={variation.images[0].medium.url}
                  alt={variation.name}
                  className="h-full w-full object-cover"
                  width={500}
                  height={500}
                />
              </BaseLink>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
